export default {
    name: "VideosList",
    props: {
        videos: {},
        game: {}
    }
};
